/**
 * The BE caps the effective watermark stack (campaign over warranty over the vehicle's own
 * selection) at `maxCount` and cuts the overflow from the bottom, so inherited watermarks take
 * slots from the own selection first.
 *
 * - `inheritedCount`: effective watermarks that are not the vehicle's own.
 * - `ownCap`: how many own watermarks still fit.
 * - `cutIds`: own watermarks the BE does not apply because the stack is full.
 */
export const getWatermarkCapState = (
  editableWatermarkIds: string[],
  effectiveWatermarkIds: string[],
  maxCount: number
) => {
  const inheritedCount = effectiveWatermarkIds.filter(
    (id) => !editableWatermarkIds.includes(id)
  ).length;

  return {
    inheritedCount,
    ownCap: Math.max(maxCount - inheritedCount, 0),
    cutIds: editableWatermarkIds.filter((id) => !effectiveWatermarkIds.includes(id)),
  };
};
